import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import { Country } from '../../shared/models/country.model';
import {Observable} from 'rxjs';
import {ApiConfigService} from './api.config.service';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CountryService {
  constructor(
    private http: HttpClient,
    private cache: HttpCacheService,
    private apiConfigService: ApiConfigService,
  ) {
  }

  getCountries(): Observable<Country[]> {
      const url = this.apiConfigService.getCountriesUrl();
      const key = `CountriesService:GET:${url}`;
      return this.cache.getOrSet<Country[]>(
        key,
        HTTP_CACHE_TTL_MS.UNIMPORTANT,
        () => this.http.get<Country[]>(url)
      ).pipe(
        map((res) => Array.isArray(res) ? res : [])
    )
  }

}
